import React from 'react';
import { Building2 } from 'lucide-react';

/**
 * Recreación ESTÁTICA de AdminAccessLogo.tsx (rama sin mergear
 * feature/resumen-multi-plan, src/components/ResumenV2/AdminAccessLogo.tsx) —
 * mismo contenedor visual que PlanLogo pero con icono genérico: el acceso de
 * admin no está ligado a una única entidad (puede administrar más de una
 * empresa), así que no tiene un logo propio que mostrar.
 */
export interface AdminAccessLogoProps {
	className?: string;
}

export const AdminAccessLogo = ({ className = '' }: AdminAccessLogoProps) => (
	<span
		// dark:border-border simplificado a dark:border-border
		// (11 sep 2026, entregable 6 de Foundations/DarkMode) — mismo token, ya
		// existe la clase con nombre.
		className={`flex flex-none items-center justify-center overflow-hidden rounded-lg border border-gray-100 bg-sidebar-accent dark:border-border ${className}`}
	>
		<Building2 data-testid="admin-access-logo" className="h-1/2 w-1/2 text-primary" />
	</span>
);
